/* lystia-blog.js - індекс блогу (T-E8-02, parity/blog.md §3 «Показати ще»; прототип blog.js more()/updateMore()).
   <lystia-blog data-section-id data-step data-total data-shown data-shown-tpl>: кнопка [data-blog-more-btn] (посилання на наступну сторінку paginate).
   Клік = Section Rendering: GET <href>&section_id=<id> -> картки [data-blog-grid] .bcard додаються в чергу; за клік показується data-step (6) карток
   (сторінка paginate = 7, тому залишок лишається в черзі). Нові картки: .reveal з затримкою i*50мс, document.lystia.reveal(grid), фокус на першу (preventScroll).
   Кнопка зникає, коли черга порожня й наступної сторінки нема; лічильник «Показано N з M» лишається. Помилка мережі -> звичайний перехід за посиланням.
   Тексти - з data-shown-tpl (locales у Liquid), у файлі їх немає. */
(function () {
  'use strict';
  if (customElements.get('lystia-blog')) return;

  class LystiaBlog extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-blog-grid]');
      this.btn = this.querySelector('[data-blog-more-btn]');
      this.countEl = this.querySelector('[data-blog-count]');
      if (!this.grid) return;
      this.step = parseInt(this.getAttribute('data-step'), 10) || 6;
      this.total = parseInt(this.getAttribute('data-total'), 10) || 0;
      this.shown = parseInt(this.getAttribute('data-shown'), 10) || 0;
      this.tpl = this.getAttribute('data-shown-tpl') || '';
      this.sectionId = this.getAttribute('data-section-id');
      this.queue = [];
      this.nextUrl = this.btn ? this.btn.getAttribute('href') : '';
      this.busy = false;
      this.onClick = this.onClick.bind(this);
      if (this.btn) this.btn.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.btn) this.btn.removeEventListener('click', this.onClick);
    }

    fetchNext() {
      var self = this;
      var url = this.nextUrl;
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return fetch(url + sep + 'section_id=' + encodeURIComponent(this.sectionId), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('blog ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('[data-blog-grid] .bcard');
          for (var i = 0; i < cards.length; i++) self.queue.push(document.importNode(cards[i], true));
          var nb = doc.querySelector('[data-blog-more-btn]');
          self.nextUrl = nb ? nb.getAttribute('href') : '';
        });
    }

    fill() {
      var self = this;
      if (this.queue.length >= this.step || !this.nextUrl) return Promise.resolve();
      return this.fetchNext().then(function () { return self.fill(); });
    }

    onClick(e) {
      e.preventDefault();
      if (this.busy) return;
      var self = this;
      this.busy = true;
      this.btn.classList.add('is-loading');
      this.btn.setAttribute('aria-busy', 'true');
      this.fill().then(function () {
        self.reveal();
      }).catch(function () {
        /* без JS-сценарію: звичайний перехід на наступну сторінку */
        window.location.href = self.btn.getAttribute('href');
      }).then(function () {
        self.busy = false;
        if (self.btn) { self.btn.classList.remove('is-loading'); self.btn.removeAttribute('aria-busy'); }
      });
    }

    reveal() {
      var batch = this.queue.splice(0, this.step);
      var calm = document.lystia && document.lystia.reducedMotion && document.lystia.reducedMotion();
      for (var i = 0; i < batch.length; i++) {
        var c = batch[i];
        if (!calm) {
          c.classList.add('reveal');
          c.style.setProperty('--reveal-delay', (i * 50) + 'ms');
        }
        this.grid.appendChild(c);
      }
      if (document.lystia && document.lystia.reveal) document.lystia.reveal(this.grid);
      this.shown += batch.length;
      this.updateMore();
      if (batch[0]) batch[0].focus({ preventScroll: true });
    }

    updateMore() {
      if (this.countEl && this.tpl) {
        this.countEl.textContent = this.tpl.replace('__S__', this.shown).replace('__T__', this.total);
      }
      if (this.btn && !this.queue.length && !this.nextUrl) {
        this.btn.removeEventListener('click', this.onClick);
        this.btn.remove();
        this.btn = null;
      }
    }
  }

  customElements.define('lystia-blog', LystiaBlog);
})();
